import { render, staticRenderFns } from "./DCAddNotes.vue?vue&type=template&id=5777255d&scoped=true&"
import script from "./DCAddNotes.vue?vue&type=script&lang=js&"
export * from "./DCAddNotes.vue?vue&type=script&lang=js&"
import style0 from "./DCAddNotes.vue?vue&type=style&index=0&id=5777255d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5777255d",
  null
  
)

export default component.exports